﻿/* LUADA 2 – LP Pflegekasse: Lead-Submit + Telefon/WhatsApp-Logik
 * v2 – UTM/fbclid-Capture, Telefon-Validierung, Event-ID fuer FB CAPI,
 *       Danke-Seiten-Redirect, Klaviyo-Source-Routing
 */
(function () {
  'use strict';

  var cfg = window.LP_PK_CONFIG || {};

  // ----------------------------------------------------------------
  // 1. Telefon (Mo-Fr 08-12) vs. WhatsApp (sonst)
  // ----------------------------------------------------------------
  function isPhoneOpen() {
    try {
      var fmt = new Intl.DateTimeFormat('de-DE', {
        timeZone: 'Europe/Berlin',
        weekday: 'short',
        hour: '2-digit',
        hour12: false
      });
      var parts = fmt.formatToParts(new Date());
      var weekday = '', hour = 0;
      parts.forEach(function (p) {
        if (p.type === 'weekday') weekday = p.value;
        if (p.type === 'hour') hour = parseInt(p.value, 10);
      });
      var isWeekday = /^(Mo|Di|Mi|Do|Fr)/i.test(weekday);
      return isWeekday && hour >= 8 && hour < 12;
    } catch (e) {
      var d = new Date();
      return d.getDay() >= 1 && d.getDay() <= 5 && d.getHours() >= 8 && d.getHours() < 12;
    }
  }

  function applyContactState() {
    var open = isPhoneOpen();
    var sec = document.getElementById('lp-secondary-cta');
    var secText = document.getElementById('lp-sec-text');
    var secPhone = document.getElementById('lp-sec-phone');
    var secWA = document.getElementById('lp-sec-whatsapp');
    if (sec) {
      sec.hidden = false;
      if (open) {
        if (secPhone) secPhone.hidden = false;
        if (secWA) secWA.hidden = true;
        if (secText) secText.textContent = 'Sie möchten lieber direkt sprechen? Wir sind erreichbar:';
      } else {
        if (secPhone) secPhone.hidden = true;
        if (secWA) secWA.hidden = false;
        if (secText) secText.textContent = 'Außerhalb der Telefonzeiten? Schreiben Sie uns auf WhatsApp:';
      }
    }
    var dPhone = document.getElementById('lp-direct-phone');
    var dWA = document.getElementById('lp-direct-whatsapp');
    if (dPhone && dWA) {
      dPhone.setAttribute('data-state', open ? 'primary' : 'secondary');
      dWA.setAttribute('data-state', open ? 'secondary' : 'primary');
    }
    var status = document.getElementById('lp-contact-status');
    var statusText = document.getElementById('lp-status-text');
    if (status && statusText) {
      if (open) {
        statusText.textContent = 'Jetzt telefonisch erreichbar';
        status.className = 'lp-contact-direct__status is-open';
      } else {
        statusText.textContent = 'Außerhalb der Servicezeit · WhatsApp antwortet am nächsten Werktag';
        status.className = 'lp-contact-direct__status is-closed';
      }
    }
  }

  // ----------------------------------------------------------------
  // Scarcity: deterministisch pro Tag der Woche
  // ----------------------------------------------------------------
  function initScarcity() {
    var leftEl = document.getElementById('lp-scarcity-left');
    var numEl = document.getElementById('lp-scarcity-num');
    if (!leftEl || !numEl) return;
    try {
      var fmt = new Intl.DateTimeFormat('de-DE', { timeZone: 'Europe/Berlin', weekday: 'short' });
      var parts = fmt.formatToParts(new Date());
      var weekday = (parts.find(function(p){return p.type==='weekday';}) || {}).value || '';
      var map = { Mo: 19, Di: 15, Mi: 11, Do: 8, Fr: 5, Sa: 3, So: 3 };
      var key = weekday.replace('.', '').slice(0,2);
      var left = map[key] !== undefined ? map[key] : 12;
      numEl.textContent = left;
      leftEl.textContent = left === 1 ? 'Platz frei' : 'Plätze frei';
    } catch (e) {}
  }

  // ----------------------------------------------------------------
  // Pre-Qualifier
  // ----------------------------------------------------------------
  function initPrequal() {
    var box = document.getElementById('lp-prequal');
    var form = document.getElementById('lp-form');
    var hidden = document.getElementById('lp-pflegegrad');
    if (!box || !form || !hidden) return;
    var btns = box.querySelectorAll('.lp-prequal__btn');
    btns.forEach(function(b){
      b.addEventListener('click', function(){
        btns.forEach(function(x){x.classList.remove('is-active');});
        b.classList.add('is-active');
        hidden.value = b.getAttribute('data-pg') || '';
        form.hidden = false;
        try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({event:'lp_prequal_select', value: hidden.value}); } catch(e){}
        setTimeout(function(){
          var first = form.querySelector('input[name="vorname"]');
          if (first) first.focus({preventScroll:false});
        }, 250);
      });
    });
  }

  // ----------------------------------------------------------------
  // UTM + fbclid aus URL (mit sessionStorage-Cache)
  // ----------------------------------------------------------------
  function getUtmParams() {
    var params = {};
    try {
      var sp = new URLSearchParams(location.search);
      ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','fbclid','gclid'].forEach(function(k){
        var v = sp.get(k); if (v) params[k] = v;
      });
      if (params.fbclid) sessionStorage.setItem('lp_fbclid', params.fbclid);
      else { var c = sessionStorage.getItem('lp_fbclid'); if (c) params.fbclid = c; }
      ['utm_source','utm_medium','utm_campaign','utm_content','utm_term'].forEach(function(k){
        if (params[k]) sessionStorage.setItem('lp_'+k, params[k]);
        else { var c2 = sessionStorage.getItem('lp_'+k); if (c2) params[k] = c2; }
      });
    } catch(e) {}
    return params;
  }

  // UUID v4 fuer FB-Pixel Event-ID (CAPI-Deduplication)
  function generateEventId() {
    try {
      return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, function(c){
        return (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16);
      });
    } catch(e) { return Math.random().toString(36).slice(2) + Date.now().toString(36); }
  }

  // ----------------------------------------------------------------
  // 2. Lead-Form Submit
  // ----------------------------------------------------------------
  function setError(msg) {
    var el = document.getElementById('lp-form-error');
    if (!el) return;
    if (msg) { el.textContent = msg; el.classList.add('is-visible'); }
    else { el.textContent = ''; el.classList.remove('is-visible'); }
  }

  function getCookie(name) {
    return document.cookie.split('; ').reduce(function (r, v) {
      var p = v.split('=');
      return p[0] === name ? decodeURIComponent(p[1]) : r;
    }, '');
  }

  function handleSubmit(e) {
    e.preventDefault();
    setError('');
    var form = e.target;
    var fd = new FormData(form);

    if ((fd.get('_hp') || '').toString().trim() !== '') { showSuccess(); return; }

    if (!(fd.get('pflegegrad') || '').toString().trim()) {
      setError('Bitte wählen Sie oben aus, ob ein Pflegegrad vorliegt.');
      var pq = document.getElementById('lp-prequal');
      if (pq && pq.scrollIntoView) pq.scrollIntoView({behavior:'smooth', block:'center'});
      return;
    }

    var required = ['vorname', 'phone', 'email', 'consent'];
    for (var i = 0; i < required.length; i++) {
      var v = fd.get(required[i]);
      if (!v || (typeof v === 'string' && !v.trim())) {
        setError('Bitte füllen Sie alle Pflichtfelder aus und akzeptieren Sie den Datenschutz.');
        var first = form.querySelector('[name="' + required[i] + '"]');
        if (first && first.focus) first.focus();
        return;
      }
    }

    var email = (fd.get('email') || '').toString().trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setError('Bitte geben Sie eine gültige E-Mail-Adresse ein.');
      var eInp = form.querySelector('[name="email"]'); if (eInp) eInp.focus();
      return;
    }

    var phone = (fd.get('phone') || '').toString().trim();
    if (!/^[\d\s\+\(\)\-\/]{6,20}$/.test(phone)) {
      setError('Bitte geben Sie eine gültige Telefonnummer ein (z. B. 0170 1234567).');
      var pInp = form.querySelector('[name="phone"]'); if (pInp) pInp.focus();
      return;
    }

    var btn = document.getElementById('lp-submit');
    if (btn) { btn.disabled = true; btn.textContent = 'Wird gesendet …'; }

    var utms = getUtmParams();
    var eventId = generateEventId();

    var payload = {
      vorname: (fd.get('vorname') || '').toString().trim(),
      nachname: (fd.get('nachname') || '').toString().trim(),
      phone: phone,
      email: email,
      pflegegrad: fd.get('pflegegrad'),
      rueckruf_zeit: (fd.get('rueckruf_zeit') || '').toString(),
      consent: !!fd.get('consent'),
      source: fd.get('source') || 'lp-pflegekasse',
      page_url: location.href,
      referrer: document.referrer || '',
      fbc: getCookie('_fbc') || '',
      fbp: getCookie('_fbp') || '',
      fbclid: utms.fbclid || '',
      utm_source: utms.utm_source || '',
      utm_medium: utms.utm_medium || '',
      utm_campaign: utms.utm_campaign || '',
      utm_content: utms.utm_content || '',
      utm_term: utms.utm_term || '',
      event_id: eventId,
      ts: new Date().toISOString()
    };

    fetch(cfg.webhookUrl || 'https://webhook.luada.de/lead', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      mode: 'cors',
      credentials: 'omit'
    }).then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      try {
        if (window.fbq) {
          window.fbq('track', 'Lead', { content_name: 'pflegekasse-zuschuss', content_category: 'lead' }, { eventID: eventId });
        }
      } catch (e) {}
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'lp_lead_submit', pflegegrad: payload.pflegegrad, utm_source: payload.utm_source, utm_campaign: payload.utm_campaign, event_id: eventId });
      } catch (e) {}
      // Event-ID für Danke-Seiten-Pixel speichern (sessionStorage)
      try { sessionStorage.setItem('lp_lead_event_id', eventId); } catch(e) {}
      showSuccess();
    }).catch(function () {
      setError('Es gab ein Problem beim Senden. Bitte versuchen Sie es erneut oder rufen Sie uns an.');
      if (btn) { btn.disabled = false; btn.textContent = 'Jetzt Zuschuss kostenlos prüfen'; }
    });
  }

  function showSuccess() {
    var form = document.getElementById('lp-form');
    var succ = document.getElementById('lp-success');
    if (form) form.style.display = 'none';
    if (succ) succ.classList.add('is-visible');
    if (succ && succ.scrollIntoView) succ.scrollIntoView({ behavior: 'smooth', block: 'center' });
    var thankYouUrl = cfg.thankYouUrl || '/pages/danke-pflegekasse';
    setTimeout(function() { try { window.location.href = thankYouUrl; } catch(e) {} }, 1800);
  }

  // ----------------------------------------------------------------
  // Sticky Mobile CTA – erst nach dem Hero einblenden
  // ----------------------------------------------------------------
  function initStickyCta() {
    var sticky = document.getElementById('lp-sticky');
    var hero = document.getElementById('lp-hero');
    if (!sticky || !hero) return;
    function check() {
      var threshold = hero.offsetTop + hero.offsetHeight;
      if (window.scrollY > threshold) {
        sticky.hidden = false;
        // next frame so transition fires
        requestAnimationFrame(function(){ sticky.classList.add('is-visible'); });
        window.removeEventListener('scroll', check, { passive: true });
      }
    }
    window.addEventListener('scroll', check, { passive: true });
  }

  // ----------------------------------------------------------------
  // 3. Init
  // ----------------------------------------------------------------
  function init() {
    applyContactState();
    setInterval(applyContactState, 5 * 60 * 1000);
    initScarcity();
    initPrequal();
    initStickyCta();
    var pageUrl = document.getElementById('lp-pageurl');
    if (pageUrl) pageUrl.value = location.href;
    var form = document.getElementById('lp-form');
    if (form) form.addEventListener('submit', handleSubmit);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();